export default __webpack_public_path__ + "static/media/backhome.05749d06.png";